import { render, staticRenderFns } from "./TipoEstudioPage.vue?vue&type=template&id=3e60c71c&"
import script from "./TipoEstudioPage.js?vue&type=script&lang=js&"
export * from "./TipoEstudioPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports